<ng-container *ngIf="!!requestSent">
  <div>
    ✅ A login link has been sent to your
    <span class="font-medium">{{
      requestSent === 'email' ? 'email address' : 'phone number'
    }}</span
    >. Please check your
    <span class="font-medium">{{
      requestSent === 'email' ? 'inbox' : 'messages'
    }}</span
    >.
  </div>

  <p class="mt-2">
    <span
      (click)="refreshPage()"
      class="font-medium text-primary-500 underline cursor-pointer"
      >Click here</span
    >
    to refresh if you already clicked the link in your
    {{ requestSent === 'email' ? 'email' : 'SMS messages' }}.
  </p>
</ng-container>

<ng-container *ngIf="!requestSent">
  <div>
    <form>
      <app-shared-input
        label="Email address"
        for="signInEmail"
        [value]="userEmail"
        [focused]="emailFocused"
        [disabled]="loadingEmail || loadingPhoneNumber"
        [errors]="
          !emailDeactivated && !emailDoesNotExist ? emailErrors : undefined
        "
        [touched]="!!emailErrors"
      >
        <input
          id="signInEmail"
          name="signInEmail"
          type="email"
          (focus)="emailFocused = true"
          (blur)="emailFocused = false"
          [disabled]="loadingEmail || loadingPhoneNumber"
          [(ngModel)]="userEmail"
          (input)="validateEmail()"
        />
      </app-shared-input>

      <app-shared-button
        [loading]="loadingEmail"
        [disabled]="loadingPhoneNumber || !!emailErrors"
        (click)="signInWithEmail()"
      >
        Send login link to My Email
      </app-shared-button>
    </form>
    <div
      *ngIf="emailDeactivated || emailDoesNotExist"
      class="input-error-message"
    >
      <ng-container *ngIf="emailDeactivated">
        <ng-container [ngTemplateOutlet]="accountLocked"></ng-container>
      </ng-container>
      <ng-container *ngIf="emailDoesNotExist">
        <ng-container
          [ngTemplateOutlet]="accountDoesNotExist"
          [ngTemplateOutletContext]="{ type: 'email' }"
        ></ng-container>
      </ng-container>
    </div>
  </div>

  <div class="mt-8" *ngIf="isMobile">
    <form>
      <app-shared-input
        label="Phone number"
        for="signInPhoneNumber"
        [value]="userPhoneNumber"
        [focused]="phoneNumberFocused"
        [disabled]="loadingEmail || loadingPhoneNumber"
        prefix="+1"
        [errors]="
          !phoneNumberDeactivated && phoneNumberDoesNotExist
            ? phoneNumberError
            : undefined
        "
        [touched]="!!phoneNumberError"
      >
        <input
          id="signInPhoneNumber"
          name="signInPhoneNumber"
          type="tel"
          (focus)="phoneNumberFocused = true"
          (blur)="phoneNumberFocused = false"
          [disabled]="loadingEmail || loadingPhoneNumber"
          [(ngModel)]="userPhoneNumber"
          mask="(000) 000-0000"
          (input)="validatePhoneNumber()"
        />
      </app-shared-input>
      <app-shared-button
        [loading]="loadingPhoneNumber"
        [disabled]="loadingEmail || !!phoneNumberError"
        (click)="signInWithPhoneNumber()"
      >
        Send login link to My Phone
      </app-shared-button>
    </form>
    <div
      *ngIf="phoneNumberDeactivated || phoneNumberDoesNotExist"
      class="input-error-message"
    >
      <ng-container *ngIf="phoneNumberDeactivated">
        <ng-container [ngTemplateOutlet]="accountLocked"></ng-container>
      </ng-container>
      <ng-container *ngIf="phoneNumberDoesNotExist">
        <ng-container
          [ngTemplateOutlet]="accountDoesNotExist"
          [ngTemplateOutletContext]="{ type: 'phone-number' }"
        ></ng-container>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #accountLocked>
  Sorry, your account is locked. Please email
  <a href="mailto:help@rebuilt.com" class="font-semibold">help@rebuilt.com</a>
  for assistance.
</ng-template>

<ng-template #accountDoesNotExist let-type="type">
  Sorry, this account does not exist.
  <span
    (click)="showSignInModal(type)"
    class="font-semibold underline cursor-pointer"
    >Join for free</span
  >
  instead.
</ng-template>
